<template>
  <div class="embla" ref="emblaRef">
    <slot />
  </div>
</template>

<script setup lang="ts">
import { emblaCarouselVue } from '@oatsovernight/storybook'
import { onBeforeUnmount, onMounted, watchEffect } from 'vue'

const props = defineProps({
  options: {
    type: Object,
    default: () => ({})
  },
  onClickNext: {
    type: Boolean,
    default: false
  }
})

const [ emblaRef, emblaApi ] = emblaCarouselVue({ container: '.embla__container', ...props.options })

onMounted(() => {
  // Embla API is now guaranteed to initialize
  if (emblaRef.value){
    console.log('emblaRef', emblaRef.value)
  }
  if (emblaApi.value){
    console.log('emblaApi', emblaApi.value)
    console.log('slideNodes', emblaApi.value.slideNodes())
  }
})

/**
 * External synced content (Splide parity)
 * Expects elements with [data-index]
 */
const attachExternalContent = () => {
  if (!emblaApi.value || !props.options.externalSelector) return

  const external = document.querySelector(props.options.externalSelector)
  if (!external) return

  const slides = external.querySelectorAll('[data-index]')

  const toggle = () => {
    const index = emblaApi.value!.selectedScrollSnap()
    slides.forEach(el => (el.style.display = 'none'))
    if (slides[index]) {
      slides[index].style.display = 'block'
    }
  }

  emblaApi.value.on('select', toggle)
  toggle()
}

/**
 * Click anywhere → next slide (Splide parity)
 */
watchEffect(() => {
  if (!props.onClickNext) return
  if (!emblaApi.value || !emblaRef.value) return

  const handleClick = () => {
    emblaApi.value!.scrollNext()
  }

  emblaRef.value.addEventListener('click', handleClick)

  onBeforeUnmount(() => {
    emblaRef.value?.removeEventListener('click', handleClick)
  })
})

watchEffect(() => {
  if (emblaApi.value) {
    attachExternalContent()
  }
})
</script>
